var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FundService } from '../../services/fund.service';
import * as html2pdf from 'html2pdf.js';
var FormatPdfSaveComponent = /** @class */ (function () {
    function FormatPdfSaveComponent(route, _fundInfoService) {
        this.route = route;
        this._fundInfoService = _fundInfoService;
    }
    FormatPdfSaveComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.route.params.subscribe(function (params) {
                            _this.FunbId = params['id'];
                            _this.dateTab4 = params['date'];
                            _this._fundInfoService.GetPDFBasket(params['id'], _this.dateTab4).subscribe(function (response) {
                                _this.Tab4PDF = response['Result'];
                                var x = 0;
                                var i;
                                for (i = 0; i < response['Result'].length; i++) {
                                    var y = +response['Result'][i]["Result"];
                                    x = x + y;
                                }
                                _this.Tab4Total = x;
                            });
                        })];
                    case 1:
                        _a.sent();
                        setTimeout(function () {
                            _this.save();
                        }, 1800);
                        return [2 /*return*/];
                }
            });
        });
    };
    FormatPdfSaveComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, content;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            filename: "export-pdf.pdf",
                            image: { type: 'pdf', quality: 0.98 },
                            html2canvas: { dpi: 192, letterRendering: true },
                            margin: [10, 5, 0, 5],
                            jsPDF: {
                                unit: 'pt',
                                width: 595,
                                format: 'a4',
                                orientation: 'portrait'
                            }
                        };
                        content = document.getElementById('pdfBasket');
                        return [4 /*yield*/, html2pdf().from(content).set(options).save()];
                    case 1:
                        _a.sent();
                        setTimeout(function () {
                            window.close();
                        }, 1500);
                        return [2 /*return*/];
                }
            });
        });
    };
    return FormatPdfSaveComponent;
}());
export { FormatPdfSaveComponent };
